module.exports = __webpack_public_path__ + "static/media/5.b9a8afb2.JPG";